import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Unauthorized from './pages/Unauthorized';
import Dashboard from './pages/Dashboard';
import RSSIngestion from './pages/RSSIngestion';
import EpaperUpload from './pages/EpaperUpload';
import PYQUpload from './pages/PYQUpload';
import Articles from './pages/Articles';
import PendingQuestions from './pages/PendingQuestions';
import ApprovedQuestions from './pages/ApprovedQuestions';
import Analytics from './pages/Analytics';
import UserManagement from './pages/UserManagement';
import MockTests from './pages/MockTests';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Toaster position="top-right" />
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/unauthorized" element={<Unauthorized />} />

          {/* Protected routes */}
          <Route path="/" element={
            <ProtectedRoute requiredPermission="view_dashboard">
              <Layout>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/articles" element={
            <ProtectedRoute requiredPermission="view_articles">
              <Layout>
                <Articles />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/pending-questions" element={
            <ProtectedRoute requiredPermission="view_questions">
              <Layout>
                <PendingQuestions />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/approved-questions" element={
            <ProtectedRoute requiredPermission="view_questions">
              <Layout>
                <ApprovedQuestions />
              </Layout>
            </ProtectedRoute>
          } />

          {/* Admin-only routes */}
          <Route path="/rss-ingestion" element={
            <ProtectedRoute requiredPermission="trigger_rss">
              <Layout>
                <RSSIngestion />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/epaper-upload" element={
            <ProtectedRoute requiredPermission="upload_epaper">
              <Layout>
                <EpaperUpload />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/pyq-upload" element={
            <ProtectedRoute requiredPermission="upload_pyq">
              <Layout>
                <PYQUpload />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/mock-tests" element={
            <ProtectedRoute requiredPermission="view_mock_tests">
              <Layout>
                <MockTests />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/analytics" element={
            <ProtectedRoute requiredPermission="view_analytics">
              <Layout>
                <Analytics />
              </Layout>
            </ProtectedRoute>
          } />

          <Route path="/user-management" element={
            <ProtectedRoute requiredPermission="view_users">
              <Layout>
                <UserManagement />
              </Layout>
            </ProtectedRoute>
          } />

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;

